import { InlineIcon } from '@iconify/react'
import { FC } from 'react'
import "./style.css"

interface ICommnBtn {
    name: string
    onApply: Function
    icon: string
}

const CommonBtn: FC<ICommnBtn> = ({ name, onApply, icon }) => {
    return (
        <button className='common-btn' onClick={() => onApply()}>
            {icon && <InlineIcon icon={icon} />}
            {name ? <label>{name}</label> : ""}
        </button>
    )
}

export default CommonBtn